import { FormikProps, useFormik } from 'formik';
import { getAddLanguageFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { ILanguage } from '../../../../types/interfaces/language';
import { FormikValues } from 'formik/dist/types';
import { usePostPutLanguage } from '../../../../services/redux/api/languagesAPI';
import { useState } from 'react';
import { useLayout } from '../../../../context/LayoutContext';
import { useGetFilePaths } from '../../../../services/redux/api/appConfigApi';
import {
  deleteFilesFromFirebase,
  uploadFileAndCreateAppFile,
} from '../../../../utils/firebase-storage-utils';

export function useAddLanguageComponent(
  onClose: () => void,
  language?: ILanguage,
) {
  const { t } = useTranslation();
  const [postPutLanguage] = usePostPutLanguage();
  const [avatar, setAvatar] = useState(null);
  const { data: filePaths } = useGetFilePaths();
  const [isLoading, setIsLoading] = useState(false);
  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddLanguageFormValidation(t),
    initialValues: {
      key: language?.key || '',
      title: language?.title || '',
      active: language?.active || false,
    },
    onSubmit: onSubmit,
  });

  async function onSubmit(values: FormikValues) {
    if (!filePaths) {
      return;
    }

    let avatarFile;
    const uploadedStoragePaths: string[] = [];

    try {
      setIsLoading(true);

      if (avatar) {
        avatarFile = await uploadFileAndCreateAppFile(
          avatar,
          filePaths.language,
        );
        uploadedStoragePaths.push(avatarFile.storageLink);
        if (avatarFile.previewStorageLink) {
          uploadedStoragePaths.push(avatarFile.previewStorageLink);
        }
      }

      await postPutLanguage({
        id: language?.id,
        body: {
          key: values.key,
          title: values.title,
          active: values.active || false,
          ...(avatarFile && { avatar: avatarFile }),
        } as any,
      }).unwrap();

      onClose();
    } catch (error) {
      console.error('Error uploading avatar or saving language:', error);
      if (uploadedStoragePaths.length > 0) {
        await deleteFilesFromFirebase(uploadedStoragePaths);
      }
    } finally {
      setIsLoading(false);
    }
  }

  return { formik, isLoading, avatar, setAvatar };
}
